var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31583 0V1.90316L11 3.02316V1.68421H19.4211V14.3158H15.2106V16H21.1053V0H9.31583ZM7.21057 2.52632L0.894775 6.73684V16H13.5264V6.73684L7.21057 2.52632ZM12.6842 3.36842V4.15158L14.04 5.05263H14.3685V3.36842H12.6842ZM16.0527 3.36842V5.05263H17.7369V3.36842H16.0527ZM7.21057 4.63158L11.8421 7.57895V14.3158H9.31583V9.26316H5.1053V14.3158H2.57899V7.57895L7.21057 4.63158ZM16.0527 6.73684V8.42105H17.7369V6.73684H16.0527ZM16.0527 10.1053V11.7895H17.7369V10.1053H16.0527Z",
    fill: "#6F9FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdress);
export default __webpack_public_path__ + "static/media/adress.137bea6d.svg";
export { ForwardRef as ReactComponent };